import { KendraConst, SearchInterface } from "@amzn/ask-legal-domain";
import { Multiselect, MultiselectProps } from "@amzn/awsui-components-react";
import * as React from "react";
import { UIModel } from "../../../model/ui-model";
import { usePageLibraryDataCache } from "../../../hooks/use-page-library-data-cache";
import { getStringFilterValues, replaceStringFilters } from "./search-filter-utils-v2";

const PAGE_LIBRARY_ID = KendraConst.ContainerIngestionKendraAttributes.Custom.PageLibraryId;

export const PageLibraryFilterV2 = (props: {
    pageLibraryIds: string[];
    queryInputState: UIModel.State<SearchInterface.SearchQueryInput>;
    disabled?: boolean;
}) => {
    const { pageLibraryCache, loadPageLibraryData } = usePageLibraryDataCache();

    React.useEffect(() => {
        loadPageLibraryData(props.pageLibraryIds);
    }, [props.pageLibraryIds, loadPageLibraryData]);

    const toOption = (id: string): MultiselectProps.Option => ({
        label: pageLibraryCache[id]?.displayName || pageLibraryCache[id]?.name || id,
        value: id
    });
    const options = props.pageLibraryIds.map(toOption);
    const selectedOptions = getStringFilterValues(props.queryInputState.value, PAGE_LIBRARY_ID).map(toOption);

    return (
        <Multiselect
            inlineLabelText="Page library"
            placeholder="All"
            filteringType="auto"
            inlineTokens
            selectedOptions={selectedOptions}
            options={options}
            disabled={props.disabled}
            onChange={({ detail }) => props.queryInputState.setValue(replaceStringFilters(
                props.queryInputState.value,
                PAGE_LIBRARY_ID,
                detail.selectedOptions.map(o => o.value).filter((v): v is string => !!v)
            ))}
        />
    );
};
